<div class="phone-login-container">
  <div class="phone-login-form">
    <div class="phone-login-form-title">PHONE LOGIN</div>

    <div class="phone-login-form-description">
      Enter your phone number and we'll send you a verification code.
    </div>

    <form [formGroup]="phoneForm" class="phone-login-form-container">
      <label class="phone-login-form-container-label">Phone Number</label>

      @if(!otpSent) {
        <wire-phone-input
          formGroupName="phone"
          [initialValue]="initialValue"
          (phoneNumberChange)="handlePhoneNumberChange($event)"
          (countryChange)="handleCountryChange($event)"
        ></wire-phone-input>
      } @else {
        <div class="phone-display">
          {{ phoneForm.value.phone?.countryCode }} {{ phoneForm.value.phone?.mobile }}
        </div>
        <div class="phone-edit-link" (click)="editPhone()">Edit phone number</div>
      }

      @if(phoneForm.get('phone')?.get('mobile')?.invalid && phoneForm.get('phone')?.get('mobile')?.touched && !otpSent) {
        <span class="phone-login-form-container-error">Please enter a valid phone number</span>
      }

      @if(otpSent) {
        <label class="phone-login-form-container-label">Verification Code</label>
        <input
          [ngClass]="{'phone-login-form-container-input__error': otpForm.get('code')?.invalid && otpForm.get('code')?.touched}"
          class="phone-login-form-container-input"
          type="text"
          [formControl]="otpCode"
          placeholder="Enter 6-digit code"
          maxlength="6">

        @if(otpForm.get('code')?.invalid && otpForm.get('code')?.touched) {
          <span class="phone-login-form-container-error">Please enter a valid 6-digit code</span>
        }

        <div class="resend-link" (click)="resendOtp()">Resend code</div>
      }

      <div class="phone-login-form-button-container">
        @if(!otpSent) {
          <button
            type="button"
            class="phone-login-form-button red-button"
            [ngClass]="{'disabled': phoneForm.get('phone')?.get('mobile')?.invalid || loading}"
            [disabled]="phoneForm.get('phone')?.get('mobile')?.invalid || loading"
            (click)="sendOtp()"
          >
            @if(loading) {
              Loading...
            } @else {
              SEND CODE
            }
          </button>
        } @else {
          <button
            type="button"
            class="phone-login-form-button red-button"
            [ngClass]="{'disabled': otpForm.invalid || loading}"
            [disabled]="otpForm.invalid || loading"
            (click)="verifyOtp()"
          >
            @if(loading) {
              Loading...
            } @else {
              VERIFY & LOGIN
            }
          </button>
        }

        <button
          type="button"
          class="phone-login-form-button dark-button"
          [routerLink]="['/login']"
        >BACK TO LOGIN</button>
      </div>
    </form>
  </div>
</div>
